

























































import { Vue, Component, Watch } from "vue-property-decorator";
import { getList } from "@/apis/question";
import { Pagination } from "element-ui";
@Component({
  components: {
    Pagination
  }
})
export default class Layout extends Vue {
  type: any = 1;
  page = 1;
  per_page = 8;
  total = 0;
  data: any = [];
  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.init();
  }
  // 改动条件清空
  change(index: number) {
    this.type = index;
    this.page = 1;
    this.total = 0;
    this.data = [];
    this.init();
  }

  handlePageChange(value: any) {
    // console.log(value);
    this.page = value;
    this.init();
  }

  // 获取列表
  async init() {
    this.data = [];
    let params = {
      page: this.page,
      per_page: this.per_page,
      project_ukey: this.type == 2 ? "mba" : "emba"
    };
    const data = await getList(params);
    if (data.data) {
      this.data.push(...data.data);
    }
    this.total = data.total;
  }
}
